<template>
  <div class="color">
    <div class="color-logo">
      <img :src="colorLogo" style="width: 18em;" />
    </div>
    <div class="title">
      <div>Nicole Han Makeup Studio</div>
      <div class="title-text">色彩测试</div>
    </div>
    <div class="choose">
      <div class="line">
        <div class="line-content">
          <div class="line-label">昵称</div>
          <input placeholder="请输入" />
        </div>
        <div class="line-content">
          <div class="line-label">日期</div>
          <input placeholder="请输入" />
        </div>
      </div>
      <div class="line">
        <div class="line-content">
          <div class="line-label">三庭</div>
          <input placeholder="请输入" />
        </div>
        <div class="line-content">
          <div class="line-label">五眼</div>
          <input placeholder="请输入" />
        </div>
      </div>
      <div class="line">
        <div class="line-content">
          <div class="line-label">唇色</div>
          <input placeholder="请输入" />
        </div>
        <div class="line-content">
          <div class="line-label">肤色</div>
          <input placeholder="请输入" />
        </div>
      </div>
      <div class="line">
        <div class="line-content">
          <div class="line-label">瞳孔色</div>
          <input placeholder="请输入" />
        </div>
        <div class="line-content">
          <div class="line-label">脸长度</div>
          <input placeholder="请输入" />
        </div>
      </div>
      <div class="line">
        <div class="line-content">
          <div class="line-label">四季色彩测试</div>
          <input placeholder="请输入" />
        </div>
        <div class="line-content">
          <div class="line-label">明度</div>
          <input placeholder="请输入" />
        </div>
      </div>
      <div class="line">
        <div class="line-content">
          <div class="line-label">饱和度</div>
          <input placeholder="请输入" />
        </div>
        <div class="line-content">
          <div class="line-label">金银色</div>
          <input placeholder="请输入" />
        </div>
      </div>
    </div>
    <div class="color-image">
      <img :src="baseURLImg + imageData" />
    </div>
    <!-- <div class="color-image">
      <img :src="color2" />
    </div> -->
    <div class="tip">
      <div>小于 0.75长脸 大于>0.75短脸 大于>5.7长发</div>
      <div>看唇色 暖调 偏橘 偏棕调 冷调 玫紫调 粉调</div>
      <div>
        看瞳孔 暖调-更加偏向于棕色系 亮茶色 棕黄色深棕色 冷调-更加偏向于玫瑰棕
        灰色 黑色
      </div>
      <div>看肤色暖调-皮肤基础色(黄调)冷调-皮肤基础色(蓝调)或者(粉调)</div>
    </div>
  </div>
</template>

<script>
import reqApi from "@/api/api.js";
import { baseURLImg } from "@/api/request.js";
export default {
  name: "ColorItem",
  components: {},
  data() {
    return {
      selectedValues: [],
      makeupQuestionList: [],
      colorLogo: require("@/assets/colorLogo.png"),
      color2: require("@/assets/color2.png"),
      color1: require("@/assets/color1.png"),
      imageData: "",
      baseURLImg: baseURLImg,
    };
  },
  created() {
    console.log("created - 实例创建完成，可以访问data和methods");
  },
  mounted() {
    console.log("mounted - 实例已挂载到DOM，可以操作DOM");

    this.getMakeupQuestion();
  },
  methods: {
    selectOption(item, index) {
      this.selectedValues[index].check = item.value;
    },
    getMakeupQuestion() {
      reqApi.colorQuestion({}).then((res) => {
        console.log(res.data.image);
        this.imageData = res.data.image;
      });
    },
  },
};
</script>

<style scoped>
.color {
  background: #ffffff;
  text-align: center;
}

.color-logo {
  text-align: center;
}

.color .title {
  font-family: 'DongFangDaKai', sans-serif;
  font-size: 3rem;
  color: #000000;
  text-align: center;
  padding: 30px 0;
}

.color .title .title-text {
  font-size: 3rem;
  color: #000000;
  text-align: center;
  margin-top: 15px;
}

.color .tip {
  font-size: 1.6em;
  color: #000000;
  text-align: center;
  margin-top: 30px;
  line-height: 80px;
}

.item-list {
  display: flex;
}

.choose {
  width: 70%;
  margin: 0 auto;
  margin-bottom: 40px;
}

.choose .line {
  display: flex;
}

.choose .line .line-content {
  display: flex;
  align-items: center;
  width: 50%;
  justify-content: space-between;
  padding: 15px;
  border: 1px solid #eeeeee;
}

.choose .line .line-label {
  font-size: 1rem;
  color: #000000;
}

.line input {
  font-size: 1em;
  border: none;
  background: transparent;
}

.color-image {
  text-align: center;
}

.color-image img {
  width: 50em;
  margin-bottom: 30px;
}

input:focus {
  outline: none;
  /* 移除默认轮廓 */
  border: none;
  /* 提供自定义焦点样式 */
}
</style>
